<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <path d="M14 4 L18 4 L18 8 L14 8 L14 11 L18 11 L17 14 L14 14 L14 21 L11 21 L11 14 L8 14 L8 11 L11 11 L11 7 C11 5 12 4 14 4 Z"/>
  </svg>
</template>
